import { createFileRoute, redirect } from '@tanstack/react-router';
import { productPath } from '@/lib/routes';

/** /app → first enabled product. */
export const Route = createFileRoute('/app/')({
  beforeLoad: ({ context }) => {
    const first = context.user.enabledProducts[0] ?? context.user.signupProduct;
    throw redirect({ to: productPath(first) });
  },
});
